
/* styles */
require("!!../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-0f115cce&scoped=true!sass-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./message-dialog.vue")

var Component = require("!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./message-dialog.js"),
  /* template */
  require("!!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-0f115cce!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./message-dialog.vue"),
  /* scopeId */
  "data-v-0f115cce",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/message-dialog.vue
// module id = 14
// module chunks = 1